<h2 mat-dialog-title>Modifier votre mot de passe</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <mat-form-field>
          <mat-label>Mot de passe actuel</mat-label>
          <input matInput placeholder="" [type]="hidePasswordActual ? 'password' : 'text'" required
            formControlName="oldPassword" autocomplete="current-password" name="current-password"
            id="current-password" />
          <mat-icon matSuffix role="button"
            [appTooltip]="hidePasswordActual ? 'Afficher le mot de passe' : 'Masquer le mot de passe'"
            (click)="hidePasswordActual = !hidePasswordActual">{{hidePasswordActual ? 'visibility_off' :
            'visibility'}}</mat-icon>
          <mat-error>
            <span *ngIf="f('oldPassword').hasError('required')">Veuillez saisir votre mot de passe</span>
            <span *ngIf="f('oldPassword').hasError('badPassword')">Mot de passe incorrect</span>
          </mat-error>
        </mat-form-field>
      </div>
      <!-- fix for autofill on IOS -->
      <input type="password" style="position: fixed;left: -1000vw;">
      <div class="row">
        <mat-form-field>
          <mat-label>Votre mot de passe</mat-label>
          <input matInput required [type]="hidePassword ? 'password' : 'text'" formControlName="newPassword"
            placeholder="" autocomplete="new-password" name="new-password" id="new-password" />
          <mat-icon matSuffix role="button"
            [appTooltip]="hidePassword ? 'Afficher le mot de passe' : 'Masquer le mot de passe'"
            (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>

          <mat-error>
            <span *ngIf="f('newPassword').hasError('required')">Veuillez saisir un mot de passe</span>
            <span *ngIf="f('newPassword').hasError('passwordDontMatch')">Les mots de passe ne correspondent
              pas</span>
            <span *ngIf="f('newPassword').hasError('pattern')">Mot de passe trop simpliste</span>
            <span *ngIf="f('newPassword').hasError('refusedPassword')">Mot de passe non autorisé<mat-icon
                mdbPopover="Trop de caractères identiques consécutifs (maximum 3)" trigger="focus"
                tabindex="0">info</mat-icon></span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field>
          <mat-label>Confirmer le mot de passe</mat-label>
          <input matInput required [type]="hidePasswordConfirm ? 'password' : 'text'"
            formControlName="passwordConfirmed" placeholder="" autocomplete="new-password" />
          <mat-icon matSuffix role="button"
            [appTooltip]="hidePasswordConfirm ? 'Afficher le mot de passe' : 'Masquer le mot de passe'"
            (click)="hidePasswordConfirm = !hidePasswordConfirm">{{hidePasswordConfirm ? 'visibility_off' :
            'visibility'}}</mat-icon>
          <mat-error>
            <span *ngIf="f('passwordConfirmed').hasError('required')">Veuillez confirmer le mot de passe</span>
          </mat-error>
        </mat-form-field>
      </div>
      <app-password-check [passwordFormField]="form_password"></app-password-check>
      <div class="formValidation" class="text-center">
        <button mat-flat-button class="m-2" color="primary" appTooltip="Valider le nouveau mot de passe" type="submit"
          [disabled]="formSubmitting">
          Valider
        </button>
        <button mat-flat-button class="m-2" color="primary" mat-dialog-close (click)="onNoClick()">
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>